document.addEventListener('DOMContentLoaded', function() {

    // Ajouter les infos manquantes d'attributs produit avec le plugin switch variations yith
    // Récupérer l'ID du produit
    const productIdElement = document.querySelector('[data-product-id]');
    
    if (productIdElement) {
        const productId = productIdElement.getAttribute('data-product-id');
        const hasVariations = document.querySelector('.variations_form');
        const hasAttributes = document.querySelector('.product-subscription__option');

        if (hasAttributes) {            
            showSubscriptionDetails();
        }

        setTimeout(function() {
            const firstOption = document.querySelector('.variations-illu .select_option');
            if (firstOption) {
                firstOption.click();
                setTimeout(function() {
                    showSubscriptionDetails();
                }, 100);
            }
        }, 1100);

        if (hasVariations) {
            const productVariations = hasVariations.getAttribute('data-product_variations');
            
            if (productVariations && productVariations.includes('attribute_pa_conditionnement')) {
                //Gérer l'affichage des variations images en fonction du nombre d'attributs
                hasVariations.classList.add('variations-illu');
            } else if (productVariations && productVariations.includes('attribute_pa_montant')) {
                hasVariations.classList.add('variations-giftcard');
            }
            fetchProductAttributeInfo(productId).then(function() {
            setTimeout(function() {
                const variationsTable = document.querySelector('table.variations');
                if (variationsTable) {
                variationsTable.style.opacity = '1';
                const tdElements = variationsTable.querySelectorAll('td');
                tdElements.forEach(function(td) {
                    td.style.height = 'auto';
                });
                }
            }, 500); // Attendre 0.5 seconde avant d'exécuter le code
            });
        }
        // Pour éviter le rechargement de yith
        setTimeout(function() {
            // Sélectionner le div que vous voulez supprimer
            const divToRemove = document.querySelector('.select_box');

            if (divToRemove) {
                // Remplacer le div par son contenu
                while (divToRemove.firstChild) {
                    divToRemove.parentNode.insertBefore(divToRemove.firstChild, divToRemove);
                }
                divToRemove.parentNode.removeChild(divToRemove);
            }
        }, 1000); // Attendre 1 seconde avant d'exécuter le code    

    }
    function showSubscriptionDetails() {            
        const subscriptionDetail = document.querySelector('.one-time-option + .subscription-option .product-subscription__detail');
        if (subscriptionDetail) {            
            subscriptionDetail.classList.add('subscription-option--selected');
        }
    }

    document.body.addEventListener('click', function(event) {
        if (event.target.closest('.select_option') || event.target.classList.contains('reset_variations')) {
            const selectBoxes = document.querySelectorAll('.select_box');
            selectBoxes.forEach(function(box) {
                box.parentNode.removeChild(box);
            });
            // Supprimer la div yith-wccl-no-selected-msg et son contenu
            const noSelectedMsgDiv = document.querySelector('.yith-wccl-no-selected-msg');
            if (noSelectedMsgDiv) {
                noSelectedMsgDiv.parentNode.removeChild(noSelectedMsgDiv);
            }
            //Afficher le prix de la première option d'abonnement quand on change de variation            
            setTimeout(function() {
                showSubscriptionDetails();
            }, 200);
        }
          
        setTimeout(function() {
            if (event.target.closest('.select_option')) {
                const variationsForm = document.querySelector('.variations_form');
                if (variationsForm && variationsForm.hasAttribute('current-image')) {
                const currentImage = variationsForm.getAttribute('current-image');
                const thumbnails = document.querySelectorAll('.product__left__thumbnails__item--var img');
                thumbnails.forEach(function(thumbnail) {
                    if (thumbnail.getAttribute('data-id') === currentImage) {
                        thumbnail.style.zIndex = '100';
                        if (thumbnail.hasAttribute('data-id')) {
                            thumbnail.style.opacity = '1';
                        }
                    } else {
                        thumbnail.style.zIndex = '-1';
                        if (thumbnail.hasAttribute('data-id')) {
                            thumbnail.style.opacity = '0';
                        }
                    }
                });

                // Si toutes les images ont z-index: -1, mettre l'image qui n'a pas d'attribut data-id en z-index: 100
                const allThumbnailsHidden = Array.from(thumbnails).every(function(thumbnail) {
                    return thumbnail.style.zIndex === '-1';
                });

                if (allThumbnailsHidden) {
                    const noDataIdThumbnail = Array.from(thumbnails).find(function(thumbnail) {
                        return !thumbnail.hasAttribute('data-id');
                    });

                    if (noDataIdThumbnail) {
                        noDataIdThumbnail.style.zIndex = '100';
                    }
                }
                }
            }
        }, 200);
    });

    document.body.addEventListener('click', function(event) {
        const allOptions = document.querySelectorAll('.product-subscription__detail');
        if(allOptions) {
            allOptions.forEach(function(option) {
                option.classList.remove('subscription-option--selected');
            });
        }
        checkSubscription();
    });

    // STICKY ADD TO CART
    const stickyBar = document.getElementById('__MyfStickyBar');
    const summary = document.querySelector('.woocommerce-product-details__short-description');
    const body = document.body;

    if (stickyBar) {
        const triggerPoint = summary.offsetTop;
        // Affichage de la barre sticky
        window.addEventListener('scroll', function () {
            if (window.scrollY > triggerPoint) {
                if (stickyBar.style.display !== 'block') {
                    stickyBar.style.display = 'block';
                    setTimeout(function() {
                        stickyBar.style.opacity = '1';
                    }, 10); // Slight delay to trigger the transition
                    body.style.paddingBottom = stickyBar.offsetHeight + 'px';
                }
            } else {
                if (stickyBar.style.display !== 'none') {
                    stickyBar.style.opacity = '0';
                    setTimeout(function() {
                        stickyBar.style.display = 'none';
                    }, 300); // Match the transition duration
                    body.style.paddingBottom = '0';
                }
            }

            checkSubscription();
        });

        const sagReviewWidget = stickyBar.querySelector('#agWidgetH');
        if (sagReviewWidget) {
            sagReviewWidget.parentNode.removeChild(sagReviewWidget);
        }

        // Synchro des formulaires d'ajout au panier
        // Identifiez les deux formulaires : celui de la fiche produit et celui de la barre sticky
        const mainForm = document.querySelector('.product__right form');
        const stickyForm = document.querySelector('#__MyfStickyBar form');

        // Synchroniser les changements de quantité
        mainForm.querySelector('input.qty').addEventListener('input', function () {
            const qty = this.value;
            stickyForm.querySelector('input.qty').value = qty;
        });

        stickyForm.querySelector('input.qty').addEventListener('input', function () {
            const qty = this.value;
            mainForm.querySelector('input.qty').value = qty;
        });

        // Synchroniser les sélections de variations
        let isSyncing = false;

        // Synchroniser les sélections de variations au chargement
        setTimeout(function() {
            mainForm.querySelectorAll('.select_option.selected').forEach(function(option) {
                const attributeName = option.getAttribute('data-attr_name');
                const selectedValue = option.getAttribute('data-value');
                const stickySelect = stickyForm.querySelector('select[name="' + attributeName + '"]');                
                isSyncing = true;
                stickySelect.value = selectedValue;
                stickySelect.dispatchEvent(new Event('change'));
                isSyncing = false;

                // Mettre à jour le prix dans la barre sticky
                const variationsForm = option.closest('.variations_form');
                if (variationsForm) {
                    updateStickyBarPrice(variationsForm);
                }
            });
        }, 500); // Attendre 0.5 seconde avant d'exécuter le code pour laisser le temps à yith de charger

        mainForm.addEventListener('click', function(event) {
            if (isSyncing) return;

            const option = event.target.closest('.select_option');
            if (option) {
                const attributeName = option.getAttribute('data-attr_name');
                const selectedValue = option.getAttribute('data-value');
                const stickySelect = stickyForm.querySelector('select[name="' + attributeName + '"]');
                isSyncing = true;
                stickySelect.value = selectedValue;
                stickySelect.dispatchEvent(new Event('change'));
                isSyncing = false;

                // Mettre à jour le prix dans la barre sticky
                const variationsForm = option.closest('.variations_form');
                if (variationsForm) {
                    updateStickyBarPrice(variationsForm);
                }
            }
        });

        stickyForm.querySelectorAll('select').forEach(function(select) {
            select.addEventListener('change', function () {
                if (isSyncing) return;
                const selectedValue = this.value;
                const mainOption = mainForm.querySelector('.select_option[data-value="' + selectedValue + '"]');
                if (mainOption) {
                    isSyncing = true;
                    mainOption.click();
                    isSyncing = false;
                }
                // Mettre à jour le prix dans la barre sticky
                const variationsForm = mainOption.closest('.variations_form');
                if (variationsForm) {
                    updateStickyBarPrice(variationsForm);
                }
            });

            stickyForm.addEventListener('show_variation', function(event) {
                const variation = event.detail;
                document.getElementById('__MyfStickyBar__price').innerHTML = variation.price_html;
            });
        });
    }

    // Ajouter au panier custom
    const secondForm = document.getElementById('sticky-bar-variations'); // Identifiez le formulaire
    let variationSelect;
    if (secondForm) {
        variationSelect = secondForm.querySelector('select[name="attribute_pa_conditionnement"]');
    }

    if (variationSelect) {
        const variationField = secondForm.querySelector('input[name="variation_id"]');
        const productVariations = JSON.parse(document.getElementById('sticky-bar-variations').dataset.product_variations);
        // Écouteur pour les changements de sélection
        variationSelect.addEventListener('change', function () {
            const selectedValue = variationSelect.value;

            // Trouver la variation correspondante
            const matchingVariation = productVariations.find(variation => {
                return variation.attributes.attribute_pa_conditionnement === selectedValue;
            });

            if (matchingVariation) {
                // Met à jour le champ variation_id
                variationField.value = matchingVariation.variation_id;
            } else {
                // Réinitialise si aucune variation ne correspond
                variationField.value = '';
            }
        });
        secondForm.addEventListener('submit', function (e) {
            if (!variationField.value) {
                e.preventDefault(); // Empêche l'envoi du formulaire
            }
        });
    }
});

function updateStickyBarPrice(variationsForm) {
    const variations = JSON.parse(variationsForm.getAttribute('data-product_variations'));
    const selectedAttributes = {};
    variationsForm.querySelectorAll('select').forEach(function(select) {
        selectedAttributes[select.name] = select.value;
    });
    const selectedVariation = variations.find(function(variation) {
        return Object.keys(selectedAttributes).every(function(attrName) {
            return variation.attributes[attrName] === selectedAttributes[attrName];
        });
    });
    if (selectedVariation) {
        let priceHtml = '';

        if (selectedVariation.display_regular_price !== selectedVariation.display_price) {
            priceHtml += '<del>' + selectedVariation.display_regular_price.toFixed(2).replace('.', ',') + ' ' + myf_currency.symbol + '</del> ';
        }
        priceHtml += selectedVariation.display_price.toFixed(2).replace('.', ',') + ' ' + myf_currency.symbol;

        document.getElementById('__MyfStickyBar__price').innerHTML = priceHtml;
    }
}

function fetchProductAttributeInfo(productId) {
    return new Promise(function(resolve, reject) {
        // Envoyer une requête AJAX pour récupérer les informations d'attributs
        const xhr = new XMLHttpRequest();
        xhr.open('POST', frontendajax.ajaxurl, true);
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
        xhr.onload = function() {
            if (xhr.status === 200) {
                const response = JSON.parse(xhr.responseText);
                if (response.success) {
                    const attributeInfo = response.data;

                    // Afficher les informations d'attributs
                    if (attributeInfo) {
                        attributeInfo.forEach(function(info) {
                            const attributeContainer = document.querySelector('.select_option[data-value="' + info.slug + '"]');
                            if (attributeContainer) {
                                const additionalInfo = document.createElement('div');
                                additionalInfo.classList.add('variation__attr');
                                additionalInfo.innerHTML = info.name + '<br /><span>' + info.description + '</span>';
                                const customDiv = document.querySelector('.yith_wccl_is_custom');
                                if (customDiv) {
                                    customDiv.appendChild(additionalInfo);
                                }
                            }
                        });
                    }
                    resolve();
                } else {
                    reject();
                }
            }
        };
        xhr.send('action=myf_get_product_attribute_info_ajax&product_id=' + productId);
    });
}

function checkSubscription() {
    //Ne pas afficher la sticky bar pour les abonnements
    const stickyBar = document.getElementById('__MyfStickyBar');
    const subscriptionWrapper = document.querySelector('.wcsatt-add-to-subscription-wrapper');
    if (subscriptionWrapper) {
        const classList = Array.from(subscriptionWrapper.classList);
        if (subscriptionWrapper.classList.contains('active')) {
            stickyBar.style.display = 'none';
        }
    }
}
